import QueryString from 'query-string';
import { Query } from '~/Api/Product';
import config from '~/config';

export default function buildProductSearchUrl(
	query: Query,
	productId: string | null = null,
	priceType: string | null = config.product.defaultPriceType,
	currency: string | null = config.product.defaultPriceCurrency,
	filterCalculatedPrice = false
): { pathname: string; search: string } {
	return {
		pathname: `/search/${productId !== null ? encodeURIComponent(productId) : ''}`,
		search: QueryString.stringify({
			filter: query.filterParameters.map((parameter) => {
				if (typeof parameter.value === 'string') {
					return `${parameter.name}:${parameter.value.trim()}`;
				}
				if (parameter.value instanceof Array) {
					return `${parameter.name}:${Array.from(parameter.value).join(',')}`;
				}
				return '';
			}),
			currency: currency !== config.product.defaultPriceCurrency ? currency ?? 'any' : undefined,
			price: priceType !== config.product.defaultPriceType ? priceType ?? 'first-available' : undefined,
			'no-calc-price': filterCalculatedPrice ? 1 : undefined,
			sort: query.sortField && query.sortField !== 'country' ? query.sortField : undefined,
			order: query.order && query.order !== 'asc' ? query.order : undefined,
		}),
	};
}
